import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "@/redux/state/language";
import { selectLanguage } from "@/redux/state/language";

// reactstrap components
import {
  Button,
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  Nav,
  Container,
} from "reactstrap";
import { Link, useLocation } from "react-router-dom";

const t_prefix = "pages.navBar.common";
export default function CommonHeader() {
  // navbar collapses states and functions
  const [navbarOpen, setNavbarOpen] = React.useState(false);
  const { currentLanguage } = useSelector(selectLanguage);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const changeLanguage = () => {
    if (currentLanguage === "en") {
      dispatch(setLanguage("ar"));
    }
    if (currentLanguage === "ar") {
      dispatch(setLanguage("en"));
    }
  };
  const isActiveLink = (linkName: string) => (linkName === pathname ? "active" : "");
  const isLtr = () => currentLanguage !== 'ar'

  return (
    <Navbar className={`navbar-transparent bg-info navbar-absolute ${isLtr() ? 'reverse-direction' : ''}`} expand="lg">
      <Container>
        <div className="navbar-translate">
          <button
            aria-expanded={navbarOpen}
            className="navbar-toggler"
            data-toggle="collapse"
            type="button"
            onClick={() => {
              document.documentElement.classList.toggle("nav-open");
              setNavbarOpen(!navbarOpen);
            }}
          >
            <span className="navbar-toggler-bar bar1"></span>
            <span className="navbar-toggler-bar bar2"></span>
            <span className="navbar-toggler-bar bar3"></span>
          </button>
          <NavbarBrand href="#pablo" onClick={(e) => e.preventDefault()}>
            {t("appName")}
          </NavbarBrand>
        </div>
        <Collapse navbar isOpen={navbarOpen}>
          <Nav className="mx-auto" navbar>
            <NavItem className={isActiveLink("/")}>
              <Link className="nav-link" to="/">
                {t(`${t_prefix}.home`)}
              </Link>
            </NavItem>
            <NavItem className={isActiveLink("/about-us")}>
              <Link className="nav-link" to="/about-us">
                {t(`${t_prefix}.aboutUs`)}
              </Link>
            </NavItem>
            <NavItem>
              <Link className="nav-link" to="/about-us">
                {t(`${t_prefix}.services`)}
              </Link>
            </NavItem>
            <NavItem>
              <Link className="nav-link" to="/contact-us">
                {t(`${t_prefix}.contactUs`)}
              </Link>
            </NavItem>
            <NavItem className="mobile-translate-btn">
              <TranslateButton
                currentLanguage={currentLanguage}
                changeLanguage={changeLanguage}
              />
            </NavItem>
          </Nav>
          <Nav className="nav navbar-right" navbar>
            <NavItem>
              <TranslateButton
                currentLanguage={currentLanguage}
                changeLanguage={changeLanguage}
              />
            </NavItem>
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
}

interface TranslateButtonProps {
  currentLanguage:  "ar" | "en"
  changeLanguage:  () => void
}
const TranslateButton: React.FC<TranslateButtonProps> = ({ currentLanguage, changeLanguage }) => (
  <Button
    className="nav-link btn-default"
    color="info"
    onClick={changeLanguage}
  >
    <p>{currentLanguage === "en" ? "العربيه" : "English"}</p>
  </Button>
);
